import { lazy } from "react";

export const PageViewPostList = lazy(() => import("./List"));
export const PageViewPostDetail = lazy(() => import("./Detail"));
